module.exports = "<span [class.warning]=\"charactersLeft <= warningLimit\">\n  {{ charactersLeft }} character{{ charactersLeft === 1 ? '' : 's' }} left\n</span>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/remaining-text-indicator/remaining-text-indicator.component.html
// module id = ../../../../../src/app/shared/components/remaining-text-indicator/remaining-text-indicator.component.html
// module chunks = 12